import OrderModal from "./OrderModal";
export default OrderModal;